import Button from "./Button"

export const ShareButton = Button
